package com.essntl.features.price.domain.model.staticprice

data class StaticPriceModel(
    val id: String,
    val createdAt: String,
    val cost: Int?,
    val sellingPrice: Int?,
    val updatedAt: String?,
    val createdBy: String?,
    val updatedBy: String?,
    val markup: PriceMarkupModel?,
)
